import premiumDashboardFeaturesSubCategory from '../config/PremiumDashboardFeaturesSubCategory';
import premiumDashboardSecuritySubCategory from '../config/PremiumDashboardSecuritySubCategory';
import premiumDashboardDomainSubCategory from '../config/PremiumDashboardDomainSubCategory';
var premiumCategory = {
    key: 'premium',
    titleStringKey: 'optionTitle_premium',
    icon: "Diamond" /* Diamond */,
    subcategories: [
        premiumDashboardFeaturesSubCategory,
        premiumDashboardSecuritySubCategory,
        premiumDashboardDomainSubCategory,
    ],
};
export default premiumCategory;
//# sourceMappingURL=category.js.map